import React from 'react';
import { Link } from 'react-router-dom';

const Button = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  to, 
  href, 
  onClick,
  type = 'button',
  disabled = false,
  ...props 
}) => {
  // Base classes
  const baseClasses = 'inline-flex items-center justify-center font-medium rounded-lg focus:outline-none transition-colors';
  
  // Size classes
  const sizeClasses = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-5 py-2.5 text-base',
    lg: 'px-8 py-3.5 text-lg',
  };
  
  // Variant classes
  const variantClasses = {
    primary: 'bg-primary text-white hover:bg-opacity-80 focus:ring-2 focus:ring-offset-2 focus:ring-primary',
    secondary: 'bg-secondary text-dark hover:bg-opacity-80 focus:ring-2 focus:ring-offset-2 focus:ring-secondary',
    outline: 'bg-transparent border border-primary text-primary hover:bg-primary hover:text-white focus:ring-2 focus:ring-offset-2 focus:ring-primary',
    dark: 'bg-dark text-white hover:bg-opacity-80 focus:ring-2 focus:ring-offset-2 focus:ring-dark',
    ghost: 'bg-transparent text-primary hover:bg-opacity-10 focus:ring-2 focus:ring-inset focus:ring-primary',
    accent: 'bg-accent text-dark hover:bg-opacity-80 focus:ring-2 focus:ring-offset-2 focus:ring-accent',
  };
  
  // Combine all classes
  const classes = `${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`;
  
  // Render based on if it's a link or button
  if (to) {
    return (
      <Link to={to} className={classes} {...props}>
        {children}
      </Link>
    );
  } else if (href) {
    return (
      <a href={href} className={classes} {...props}>
        {children}
      </a>
    );
  } else {
    return (
      <button 
        type={type} 
        className={classes} 
        onClick={onClick} 
        disabled={disabled}
        {...props}
      >
        {children}
      </button>
    );
  }
};

export default Button;